import React from "react";
import "../../City/CityInfo/style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Form, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
// , FormControl
import PKButton from "components/Button/Button";
// import CoverPhoto from "pages/City/CityInfo/CoverPhoto";
//import SocialMedia from "pages/City/CityInfo/SocialMedia";
//import CityAdmin from "pages/City/CityInfo/CityAdmin";
// import PlaceholderImage from "Assets/present-img.png";
import { BlockPicker } from 'react-color';
//import { apiUrl, myHeaders_Autorized, HeaderConfig,events_list_api, channel_list_api, myHeaders_With_Cache_Control } from "Api/Api";
import { apiUrl, myHeaders_With_Cache_Control, myHeaders_Authorized, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import axios from 'axios';
import { NavLink } from "react-router-dom";
// import { local_routes } from 'utils/Routes';
// import { get_current_unix_stamp } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
// import Select from 'react-select';
import MultipleImagesUpload from 'components/MultipleImagesUpload/MultipleImagesUpload';

class PechaKuchaInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          tophat_info: {},
          youtube_info: {},
          youtube_uuid: null,
          //tophat_display_flag: null,            
          update_loading: false,
          homepage_banner_images_uuid: null,
          tophat_uuid: null,
          banner_image_urls_array: [],
          local_file_image_array: [],
          loading: true,
          message: null
        };
        
        this.max_banner_images = 20;
        

    }

    componentDidMount = async function () {
        await this.getFromApi();
    }

    getFromApi = async () => {
        this.setState({ loading: true, message: null });
        let new_state = {...this.state};
        console.log("PechaKuchaInfo getFromApi new_state 1",JSON.stringify(new_state,null,2));
        try {
            let [homepage_banner_images_response,public_site_response,homepage_response] = await Promise.all([
                axios.get(`${apiUrl}managed_contents/homepage_banner_images`, myHeaders_Auth_With_Cache_Control),
                axios.get(`${apiUrl}managed_contents/public_site`, myHeaders_Auth_With_Cache_Control),
                axios.get(`${apiUrl}managed_contents/homepage`, myHeaders_Auth_With_Cache_Control),
                //axios.get(`${apiUrl}organizations/${org_friendly_url}`, myHeaders_With_Cache_Control),
                //axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations`, myHeaders_With_Cache_Control)
            ]);
            
            if (homepage_response.data.content_sections && homepage_response.data.content_sections['youtube_embed_section_01']) {
              new_state.youtube_uuid = homepage_response.data.entity_uuid;
              new_state.youtube_info = homepage_response.data.content_sections['youtube_embed_section_01'];
              if (!('display_flag' in new_state.youtube_info)) {
                new_state.youtube_info.display_flag = true;
              }
            } else {
              new_state.youtube_info.display_flag = false;
            }
            
            new_state.homepage_banner_images_uuid = homepage_banner_images_response.data.entity_uuid;
            new_state.banner_image_urls_array = [];
            if (homepage_banner_images_response.data.image_urls) {
                for (let image_url of homepage_banner_images_response.data.image_urls) {
                    // so MultipleImagesUpload (RUG) will be happy
                    new_state.banner_image_urls_array.push({ source: image_url, name: image_url.split('/').pop() });
                }
            }
            
            if (public_site_response.data.content_sections && public_site_response.data.content_sections['tophat_section_01']) {
              new_state.tophat_uuid = public_site_response.data.entity_uuid;
              new_state.tophat_info = public_site_response.data.content_sections['tophat_section_01'];
              if (!('display_flag' in new_state.tophat_info)) {
                new_state.tophat_info.display_flag = true;
              }
            } else {
              new_state.tophat_info.display_flag = false;
            }
            
            new_state.message = null;
            new_state.loading = false;
 
            console.log("PechaKuchaInfo getFromApi new_state 2",JSON.stringify(new_state,null,2));
            this.setState(new_state);
        } catch (err) {
            console.error("Something wrong!",err);
            this.setState({loading:false});
        }
        //window.scrollTo(0, 0);
    }



    onChangeImages = async (local_file_image_array) => {
        local_file_image_array = local_file_image_array.sort((a, b) => a.name.localeCompare(b.name));
        if (local_file_image_array.length > this.max_banner_images) {
            local_file_image_array.length = this.max_banner_images;
        }
        //console.log("onChangeImages",this.state.banner_image_urls_array,local_file_image_array);
        this.setState({ local_file_image_array });
    };

    uploadAdditionalPic = async (image_obj,index = null) => {
        console.log("uploadAdditionalPic",image_obj);
        if (image_obj && !image_obj.file) {
            return image_obj['source'];
        }
        if (image_obj && image_obj.file) {
            let coverPicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(image_obj.file);
                reader.onload = () => resolve(reader.result);
            });
    
            let conImgName =  image_obj.name.replace(/[^A-Za-z0-9.]/g, "");
            
            let multi_image_upload_data = await axios.post(`${apiUrl}managed_contents/${this.state.homepage_banner_images_uuid}/getUploadSignedUrl?asset_type=images&filename=${conImgName}`, {}, myHeaders_Authorized);
            const config = { headers: { "Content-Type": multi_image_upload_data.data.content_type } };
            let uploadUrl = multi_image_upload_data.data.upload_url;
              
            var arrVal = await coverPicPromise;
            await axios.put(uploadUrl, arrVal, config);
    
            return multi_image_upload_data.data.asset_url;
        }
    }

    updatePechaKucha = async () => {
        console.log("updatePechaKucha",this.state.local_file_image_array);
        
        // validate tophat
        if (this.state.tophat_info.display_flag) {
          if (!this.state.tophat_info.introduction || !this.state.tophat_info.text_content || !this.state.tophat_info.link_text || !this.state.tophat_info.link_url) {
            this.setState({
              message: <span style={{ color: 'red' }}>If showing Top Hat, please populate each field</span>
            });
            return;
          }
        }
        
        if (this.state.youtube_info.display_flag) {
          if (!this.state.youtube_info.link_url) {
            this.setState({
              message: <span style={{ color: 'red' }}>If showing Youtube, please populate each field</span>
            });
            return;
          }
        }
        
        this.setState({ update_loading: true, loading: true });
        
        let updateImgArrays = [];
        if (this.state.local_file_image_array.length > 0) {
          let uploadAdditionalPic_promises = [];
          for (let i = 0; i < this.state.local_file_image_array.length; i++) {
              uploadAdditionalPic_promises.push(this.uploadAdditionalPic(this.state.local_file_image_array[i],i));
          }
          updateImgArrays = await Promise.all(uploadAdditionalPic_promises);
        }
        
        
        // setup tophat patch_obj
        let tophat_patch_obj = {
          content_sections: {
            'tophat_section_01': this.state.tophat_info
          }
        };
        
        let youtube_patch_obj = {
          content_sections: {
            'youtube_embed_section_01': this.state.youtube_info
          }
        }
        
        // re-order in the database
        await Promise.all([
          axios.patch(`${apiUrl}managed_contents/${this.state.homepage_banner_images_uuid}`, { "image_urls": updateImgArrays }),
          axios.patch(`${apiUrl}managed_contents/${this.state.tophat_uuid}`, tophat_patch_obj ),
          axios.patch(`${apiUrl}managed_contents/${this.state.youtube_uuid}`, youtube_patch_obj ),
        ]);
        //await axios.patch(`${apiUrl}managed_contents/${this.state.homepage_banner_images_uuid}`, { "image_urls": updateImgArrays }, myHeaders_Authorized);
        
        // refresh page
        this.setState({ update_loading: false });
        // break public cache so homepage updates immediately
        await Promise.all([
          axios.get(`${apiUrl}managed_contents/homepage_banner_images`, myHeaders_With_Cache_Control),
          axios.get(`${apiUrl}managed_contents/public_site`, myHeaders_With_Cache_Control),
          axios.get(`${apiUrl}managed_contents/homepage`, myHeaders_With_Cache_Control)
        ]);
        window.location.reload();
        //await this.getFromApi();
    }

    toggleTopHatDisplay = () => {
      console.log("toggleTopHatDisplay");
      this.setState({
        tophat_info: {
          ...this.state.tophat_info,
          display_flag: !this.state.tophat_info.display_flag
        }
      })
    };
    
    handleTopHatChange = (field,value) => {
      console.log("handleTopHatChange",field,value);
      this.setState({
        tophat_info: {
          ...this.state.tophat_info,
          [field]: value
        }
      })
    }
    
    toggleYoutubeDisplay = () => {
      console.log("toggleYoutubeDisplay");
      this.setState({
        youtube_info: {
          ...this.state.youtube_info,
          display_flag: !this.state.youtube_info.display_flag
        }
      })
    };
    
    handleYoutubeChange = (field,value) => {
      console.log("handleYoutubeChange",field,value);
      this.setState({
        youtube_info: {
          ...this.state.youtube_info,
          [field]: value
        }
      })
    }

    render() {
            
        if (this.state.loading) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            );
        }

        return (
            <div className="city-info">
                <div className="container pad-bot30">
                <Row className="pad-top70 pad-bot30 editCity">
                    <Col lg={6} md={6} sm={6} className="pad0" >
                        <h1>PechaKucha Info</h1>
                    </Col>
                    <Col lg={6} md={6} sm={6} className="pad0" >
                        <div className="cityUpdate-btn">
                            <NavLink to="/">
                                <PKButton theme="btn-global btn-hover btn-cancel ">Cancel</PKButton>
                            </NavLink>
                            { this.state.update_loading === false ?
                                <PKButton OnClickMet={this.updatePechaKucha} theme="btn-global btn-hover btn-green btn-update">Update PechaKucha</PKButton>
                                :
                                <ActivityIndicator theme="button-Status-Loader" />
                            }
                        </div>
                     </Col>
                </Row>
                
                { this.state.message &&
                  <Row>
                    {this.state.message}
                  </Row>
                }
                
                <Row style={{ border: "1px solid #d8d8d8", marginBottom: "30px" }}>
                  <Col xs={12}>
                    <h3>Top Hat</h3>
                    <Row>
                      <Col xs={2}>
                        Display?
                      </Col>
                      <Col xs={10}>
                        <ToggleButtonGroup
                          size="sm"
                          type="radio"
                          name="tophat_display_flag"
                          value={this.state.tophat_info.display_flag}
                          onChange={this.toggleTopHatDisplay}
                        >
                          <ToggleButton
                            size="sm"
                            variant="outline-secondary"
                            value={true}
                          >
                            {this.state.tophat_info.display_flag ? 'Shown' : 'Show'}  
                          </ToggleButton>
                          <ToggleButton
                            size="sm"
                            variant="outline-secondary"
                            value={false}
                          >
                            {this.state.tophat_info.display_flag ? 'Hide' : 'Hidden'}
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        Color
                      </Col>
                      <Col xs={9}>
                        <BlockPicker
                          color={ this.state.tophat_info.introduction || '#FFFFFF' }
                          onChangeComplete={ (color,event) => this.handleTopHatChange('introduction',color.hex) }
                          triangle="hide"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        Beginning Text
                      </Col>
                      <Col xs={9}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            value={this.state.tophat_info.text_content || ''}
                            onChange={ (event) => this.handleTopHatChange('text_content',event.target.value) }
                            maxLength={128}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        Link Text
                      </Col>
                      <Col xs={9}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            value={this.state.tophat_info.link_text || ''}
                            onChange={ (event) => this.handleTopHatChange('link_text',event.target.value) }
                            maxLength={64}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        Link URL<br/>
                        <span style={{ fontSize: "smaller", fontStyle: "italic" }}>(remote, eg. 'https://...') OR path (local, eg. '/events/my-great-event')</span>
                      </Col>
                      <Col xs={9}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            value={this.state.tophat_info.link_url || ''}
                            onChange={ (event) => this.handleTopHatChange('link_url',event.target.value) }
                            maxLength={512}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                  </Col>
                </Row>
                
                <Row style={{ border: "1px solid #d8d8d8", marginBottom: "30px" }}>
                  <Col xs={12}>
                    <h3>Youtube Embed on Homepage</h3>
                    <Row style={{ marginBottom: '10px' }}>
                      <Col xs={2}>
                        Display?
                      </Col>
                      <Col xs={10}>
                        <ToggleButtonGroup
                          size="sm"
                          type="radio"
                          name="youtube_display_flag"
                          value={this.state.youtube_info.display_flag}
                          onChange={this.toggleYoutubeDisplay}
                        >
                          <ToggleButton
                            size="sm"
                            variant="outline-secondary"
                            value={true}
                          >
                            {this.state.youtube_info.display_flag ? 'Shown' : 'Show'}  
                          </ToggleButton>
                          <ToggleButton
                            size="sm"
                            variant="outline-secondary"
                            value={false}
                          >
                            {this.state.youtube_info.display_flag ? 'Hide' : 'Hidden'}
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        Youtube Video Header Text
                      </Col>
                      <Col xs={9}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            value={this.state.youtube_info.title || ''}
                            onChange={ (event) => this.handleYoutubeChange('title',event.target.value) }
                            maxLength={64}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        Youtube Video Id
                      </Col>
                      <Col xs={9}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            value={this.state.youtube_info.link_url || ''}
                            onChange={ (event) => this.handleYoutubeChange('link_url',event.target.value) }
                            maxLength={64}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className="cover-photo">
                    <MultipleImagesUpload
                        //customRequest={this.customRequest}
                        onChangeImages={this.onChangeImages}
                        max_images={this.max_banner_images}
                        //imageValidator={imageValidator}
                        savedMultiImages={this.state.banner_image_urls_array}
                        uploadErrorMessage={this.uploadErrorMessage}
                    />
                </Row>
                </div>
            </div>
        );
        

    }
}

export default PechaKuchaInfo;
